/**
 * Contains props that are shared between your row component and the base TableRow component.
 *
 * This mixin should be included in any row components you create. If you need additional props for whatever
 * you are making, you can add another props: {} property directly in your component and Vue will merge
 * the data together for you automatically.
 *
 * By using this prop, you can just set attribute v-bind="$props" on the base row component and all props will be passed
 * down to the base row automatically.
 *
 * Example
 * // MyCoolTableRow.vue
 *  <template>
 *    <base-table-row v-bind="$props">
 *          <!-- insert custom logic here -->
 *    </base-table-row>
 *  </template>
 *
 **********
 * Select item checkbox
 * ********
 * If you want to remove the "select me" checkbox, set :selectable prop to false
 *
 */
export default {
  props: {
    /**
     * The data object to display
     */
    item: {
      type: Object,
      default() {
        return {}
      }
    },

    /**
     * The position of this item in the table. If first item in the list, index = 0. If second item, index = 1. Etc
     * Passed back to parent component when the checkbox is clicked
     */
    index: {
      type: Number,
      required: true
    },

    /**
     * Is this row selected
     */
    selected: {
      type: Boolean,
      default: false
    },

    /**
     * If false we don't show the 'select me' checkbox
     */
    selectable: {
      type: Boolean,
      default: true
    },

    /**
     * An array of strings indicating actions that can be performed on this item
     */
    actions: {
      type: Array,
      default() {
        return []
      }
    },

    /**
     * An array of strings indicating actions we have permission to perform on this row. If empty we can perform
     * anything, otherwise we can only perform actions listed here
     */
    can: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
